import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { errorMsg } from 'utils';

export const CHILD_CATEGORY_FETCH_INIT = createAction('CHILD_CATEGORY_FETCH_INIT');
export const CHILD_CATEGORY_FETCH_SUCCESS = createAction('CHILD_CATEGORY_FETCH_SUCCESS');
export const CHILD_CATEGORY_FETCH_FAIL = createAction('CHILD_CATEGORY_FETCH_FAIL');

export const CHILD_CATEGORY_CREATE_INIT = createAction('CHILD_CATEGORY_CREATE_INIT');
export const CHILD_CATEGORY_CREATE_SUCCESS = createAction('CHILD_CATEGORY_CREATE_SUCCESS');
export const CHILD_CATEGORY_CREATE_FAIL = createAction('CHILD_CATEGORY_CREATE_FAIL');

export const CHILD_CATEGORY_EDIT_INIT = createAction('CHILD_CATEGORY_EDIT_INIT');
export const CHILD_CATEGORY_EDIT_SUCCESS = createAction('CHILD_CATEGORY_EDIT_SUCCESS');
export const CHILD_CATEGORY_EDIT_FAIL = createAction('CHILD_CATEGORY_EDIT_FAIL');

export const CHILD_CATEGORY_DELETE_INIT = createAction('CHILD_CATEGORY_DELETE_INIT');
export const CHILD_CATEGORY_DELETE_SUCCESS = createAction('CHILD_CATEGORY_DELETE_SUCCESS');
export const CHILD_CATEGORY_DELETE_FAIL = createAction('CHILD_CATEGORY_DELETE_FAIL');

export const CHILD_CATEGORY_SET = createAction('CHILD_CATEGORY_SET');
export const CHILD_CATEGORY_CLEAN_UP = createAction('CHILD_CATEGORY_CLEAN_UP');

export const fetchChildCategories = ({ siteId }) => {
  return async (dispatch) => {
    dispatch(CHILD_CATEGORY_FETCH_INIT());

    try {
      const res = await axios.get(`${url}/childComponentCategory/list`, {
        params: { siteId },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      return dispatch(CHILD_CATEGORY_FETCH_SUCCESS({ list: res.data.data }));
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(CHILD_CATEGORY_FETCH_FAIL({ error }));
    }
  };
};

export const createChildCategory = ({ name, description, siteId }, callback) => {
  return async (dispatch) => {
    dispatch(CHILD_CATEGORY_CREATE_INIT());

    try {
      const res = await axios.post(
        `${url}/childComponentCategory/create`,
        { name, description, siteId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );

      toastr.success('', 'Category created successfully');
      dispatch(CHILD_CATEGORY_CREATE_SUCCESS({ category: res.data.data }));
      if (callback) callback();
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(CHILD_CATEGORY_CREATE_FAIL({ error }));
    }
  };
};

export const editChildCategory = ({ id, name, description, siteId }, callback) => {
  return async (dispatch) => {
    dispatch(CHILD_CATEGORY_EDIT_INIT());

    try {
      const res = await axios.post(
        `${url}/childComponentCategory/edit`,
        { id, name, description, siteId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );

      toastr.success('', 'Category updated successfully');
      dispatch(CHILD_CATEGORY_EDIT_SUCCESS({ category: res.data.data }));
      if (callback) callback();
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(CHILD_CATEGORY_EDIT_FAIL({ error }));
    }
  };
};

export const deleteChildCategory = (id, siteId, callback) => {
  return async (dispatch) => {
    dispatch(CHILD_CATEGORY_DELETE_INIT());

    try {
      await axios.delete(`${url}/childComponentCategory/delete`, {
        params: { id, siteId },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      toastr.success('', 'Category deleted successfully');
      dispatch(CHILD_CATEGORY_DELETE_SUCCESS({ id }));
      if (callback) callback();
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(CHILD_CATEGORY_DELETE_FAIL({ error }));
    }
  };
};

export const setChildCategory = (category, callback) => {
  return (dispatch) => {
    dispatch(CHILD_CATEGORY_SET(category));
    if (callback) callback();
  };
};

export const childCategoryCleanUp = () => {
  return (dispatch) => {
    dispatch(CHILD_CATEGORY_CLEAN_UP());
  };
};
